import { createFeatureSelector, MemoizedSelector } from '@ngrx/store';
import { ORDER_FEATURE } from '../../root';
import { OrderState, StateWithOrder } from '../order-state';

export const getOrderState: MemoizedSelector<StateWithOrder, OrderState> =
  createFeatureSelector<OrderState>(ORDER_FEATURE);
